// Global Instructions Rule Applied!
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import type { RootState } from '../../state_manager/store.ts'
import { getReportingDefaultSorting, type SortConfig } from './tableViewPreferences.ts'

/**
 * Returns the cfg-driven default sort for a report, mirrored into Redux from
 * `cfg.reporting_default_sort` via the globalConfigs payload. Each module's
 * data hook + page component reads this when the user has no persisted
 * `table_sorting` preference.
 *
 * `[]` when the report id is undefined (not yet resolved) or the report has
 * no default-sort rows — treat as "no sort" / use the natural row order from
 * the data RPC.
 */
export function useReportingDefaultSorting(
  reportingConfigId: string | null | undefined
): SortConfig[] {
  // Read the slice array directly — never `?? []` here, which would mint a
  // new empty-array reference on every render and defeat the useMemo below.
  const reportingDefaultSorts = useSelector(
    (s: RootState) => s.globalConfigs?.reporting_default_sorts
  )
  return useMemo(
    () => getReportingDefaultSorting(reportingConfigId, reportingDefaultSorts),
    [reportingConfigId, reportingDefaultSorts]
  )
}
